import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { CommonConstant } from '@app/common/constant/common.constant';
import { WAlertConstant } from '@app/common/constant/w-alert-icon.constant';
import { AuthUtil } from '@app/common/util/auth.util';
import { CommonUtils } from '@app/common/util/common.util';
import { ConvertUtil } from '@app/common/util/convert.util';
import { ValidationUtil } from '@app/common/util/validation.util';
import { OrderMstModel } from '@app/models/myoffice/order/order-mst.model';
import { OrdPdtModel } from '@app/models/shoppingmall/order-pdt.model';
import { SmPayHeaderModel } from '@app/models/system/sm-pay-header.model';
import { SmWownetConfigModel } from '@app/models/system/sm-wownet-config.model';
import { SmWownetPgModel } from '@app/models/system/sm-wownet-pg.model';
import { SmWownetModel } from '@app/models/system/sm-wownet.model';
import { WownetWordModel } from '@app/models/system/wownet-word.model';

import * as whishListPdtAction from '@app/actions/shoppingmall/wishlist-pdt.action';
import {
	CartState,
	getCartInfo,
} from '@app/selectors/shoppingmall/cart.selector';
import {
	PdtWishListState,
	getWishlist,
} from '@app/selectors/shoppingmall/wishlist-pdt-selector';
import {
	getFindPayHeader,
	getSmWownet,
	getSmWownetConfig,
	getSmWownetPg,
	getWowWord,
	SmWownetState,
} from '@app/selectors/system/sm-wownet.selector';
import { CartService } from '@app/services/shoppingmall/cart.service';
import { ProductService } from '@app/services/shoppingmall/product.service';
import { WishListPdtService } from '@app/services/shoppingmall/wishlist-pdt.service';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { setWAlert } from '@app/actions/w-alert.action';
import { WAlertState } from '@app/selectors/w-alert.selector';
import { TranslateService } from '@ngx-translate/core';
import { MyProgramConstant } from '@app/common/constant/my-program.constant';
import { Router } from '@angular/router';
import { CartUtil } from '@app/common/util/cart.util';
import { OverlayLoadingState } from '@app/selectors/overlay-loading.selector';
import { setShowOverlayLoading } from '@app/actions/overlay-loading.action';
import { addToCart, setIsBuyNow, setShowAlert } from '@app/actions/shoppingmall/cart.action';
import { actionSetWishYN } from '@app/actions/shoppingmall/wishlist-pdt.action';

@Component({
	selector: '[product]',
	templateUrl: './product.component.html',
	styleUrls: ['./product.component.css'],
})
export class ProductComponent implements OnInit {
	@Input()
	product: OrdPdtModel = {} as OrdPdtModel;

	@Input()
	kind: string = '';

	@Input()
	cateCd: string = '';

	@Input()
	review: boolean = true;

	@Input()
	tag: boolean = true;

	@Input()
	iconTotalReview: boolean = false;

	@Input()
	enableTotalReview: boolean = false;

	@Input()
	price: boolean = false;

	@Input()
	category: boolean = false;

  @Output()
  changeWish = new EventEmitter();

  isLogined: boolean = AuthUtil.isLogined();

	smPayHeader$ = new Observable<SmPayHeaderModel>();

	smWowWord$ = new Observable<WownetWordModel>();
	smWowWord: any = {} as WownetWordModel;

	smWownet$ = new Observable<SmWownetModel>();
	smWownet: any = {} as SmWownetModel;

	smWownetPg$ = new Observable<SmWownetPgModel>();
	smWownetPg: any = {} as SmWownetPgModel;

	cartInfo$ = new Observable<OrderMstModel[]>();
	cartInfo: OrderMstModel[] = {} as OrderMstModel[];

	smConfig$ = new Observable<SmWownetConfigModel>();
	smConfig: SmWownetConfigModel = {} as SmWownetConfigModel;

	productWishYN: Map<string, string> = new Map();
	productWishYN$ = new Observable<Map<string, string>>();

	member = AuthUtil.getLoginedInfo();
	actionConfirmLogined: string = "action_confirm_logined";

	today: string = '';
	wishYN: string = '';

	urlWownet: string = CommonConstant.URL_WOWNET;

	pointRate: number = 0;
	isLogin: boolean = AuthUtil.isLogined();
	isPv1: boolean = false;
	isPv2: boolean = false;
	isPv3: boolean = false;
	isRetailAmt: boolean = false;
	isAmt: boolean = false;
	isOrd: boolean = false;
	isPoint: boolean = false;
	isConsumer: boolean = false;
	isLinkGuest: boolean = false;
	isLinkCart: boolean = false;
	lang: string = CommonUtils.getLang();

  	userKind: string = '';

  	quantities: number = 1;
 	plus: string = "+";
  	minus: string = "-";

	constructor(
		private _cartStore: Store<CartState>,
		private _smWownetStateStore: Store<SmWownetState>,
		private _cartService: CartService,
		private _productService: ProductService,
    private _router : Router,
		private _wishListService: WishListPdtService,
		private _wishListStore: Store<PdtWishListState>,
		private _wAlertStore: Store<WAlertState>,
		private _translateService: TranslateService,
    private _overlayLoadingStore: Store<OverlayLoadingState>,
	) {
		this.smPayHeader$ = this._smWownetStateStore.select(getFindPayHeader);
		this.smWowWord$ = this._smWownetStateStore.select(getWowWord);
		this.smWownet$ = this._smWownetStateStore.select(getSmWownet);
		this.smWownetPg$ = this._smWownetStateStore.select(getSmWownetPg);
		// this.cartInfo$ = this._cartStore.select(getCartInfo);
		this.smConfig$ = this._smWownetStateStore.select(getSmWownetConfig);
		this.productWishYN$ = this._wishListStore.select(getWishlist);
	}

	ngOnInit(): void {
		// this.isLinkGuest = CommonUtils.isLinkGuest();
		// this.isConsumer = CommonUtils.isConsumer();
		// this.isLinkCart = CommonUtils.isLinkCart();
		this.wishYN = ConvertUtil.convertToString(this.product.wishYN);
    let member = AuthUtil.getLoginedInfo();
    this.userKind = ConvertUtil.convertToSring(member?.userKind).substr(3, 3);

		this.initData(
			this.smPayHeader$,
			this.smWowWord$,
			this.smWownet$,
			this.smWownetPg$,
			this.smConfig$
		);

		this.cartInfo$.subscribe((res) => {
			if (ValidationUtil.isNotNullAndNotEmpty(res)) {
				this.cartInfo = res;
			}
		});

		this.productWishYN$.subscribe((res) => {
			if (res.size > 0) {
				for (const [key, value] of res) {
					if (
						key == ConvertUtil.convertToString(this.product.pdtCd)
					) {
						this.wishYN = value;
					}
				}
			}
		});
	}

	onClickProductDetail(item: OrdPdtModel): void {
		//this._productService.getItemOfProduct(item, this.smWownet.lShowPdtYn);
	}

	onAddToCart(): void {
    if (this.isLogined) {
          let params = CartUtil.getParamsAddToCart(String(this.product.pdtCd), this.quantities);
          this._overlayLoadingStore.dispatch(setShowOverlayLoading({ loading: true }));
          this._cartStore.dispatch(setShowAlert({ show: true }));
          this._cartStore.dispatch(setIsBuyNow({ isBuyNow: false }));
          this._cartStore.dispatch(addToCart({ params: params }));
    } else {
      this.showAlertRequiredLogined();
    }



	}

	onClickWishList(event: any): void {
		this.wishYN = this._wishListService.addWishList(
			ConvertUtil.convertToString(this.product.pdtCd),
			this.wishYN
		);

		this._wishListStore.dispatch(
			actionSetWishYN({
				pdtCd: ConvertUtil.convertToString(this.product.pdtCd),
				wishYn: this.wishYN,
			})
		);
    this.changeWish.emit()
		event.stopPropagation();
	}


	initData(
		smPayHeader$: Observable<SmPayHeaderModel>,
		smWowWord$: Observable<WownetWordModel>,
		smWownet$: Observable<SmWownetModel>,
		smWownetPg$: Observable<SmWownetPgModel>,
		smConfig$: Observable<SmWownetConfigModel>
	) {
		smPayHeader$.subscribe((res) => {
			if (ValidationUtil.isNotNullAndNotEmpty(res)) {
				this.isPv1 = CommonUtils.getYN(
					ConvertUtil.convertToString(res.pv1)
				);
				this.isPv2 = CommonUtils.getYN(
					ConvertUtil.convertToString(res.pv2)
				);
				this.isPv3 = CommonUtils.getYN(
					ConvertUtil.convertToString(res.pv3)
				);
			}
		});

		smWownet$.subscribe((res) => {
			if (ValidationUtil.isNotNullAndNotEmpty(res)) {
				this.smWownet = res;
				this.isAmt = res.lShowAmtYn === CommonConstant.YES;
				this.isRetailAmt = res.lShowRetailYn === CommonConstant.YES;
				this.isOrd = res.lOrdYn === CommonConstant.YES;
			}
		});

		smWowWord$.subscribe((res) => {
			if (ValidationUtil.isNotNullAndNotEmpty(res)) {
				this.smWowWord = res;
			}
		});

		smWownetPg$.subscribe(
			(res) => (this.isPoint = res.mpoint === CommonConstant.YES)
		);

		smConfig$.subscribe((res) => {
			if (ValidationUtil.isNotNullAndNotEmpty(res)) {
				this.pointRate = Number(res.oUsePointRate);
			}
		});
	}

	showAlertRequiredLogin(): void {
		this._wAlertStore.dispatch(setWAlert({ wAlert: { icon: WAlertConstant.confirm, message: this._translateService.instant("msg.purchase.required.login"), action: this.actionConfirmLogined } }));
	}

  handleOnClickProductDetail(item: OrdPdtModel): void {
    if (ValidationUtil.isNotNullAndNotEmpty(item.pdtCd)) {

      if (this.smWownet.lShowPdtYn !== "Y" && !this.isLogined) {
        this.showAlertRequiredLogined();
      } else {
        this._router.navigate([MyProgramConstant.urlShopping + `/product/${item.pdtCd}`]);
      }
    }
  }

    showAlertRequiredLogined(): void {
      this._wAlertStore.dispatch(setWAlert({ wAlert: { icon: WAlertConstant.confirm, message: this._translateService.instant("msgRequiredLogin"), action: this.actionConfirmLogined } }));
    }

    isMatchDate(sdate :String , edate:String ) :boolean{
      if(ValidationUtil.isNotNullAndNotEmpty(sdate) || ValidationUtil.isNotNullAndNotEmpty(edate)){
        let check = true;
        const currentDate = Number(this.getCurrentDate())
        if(Number(sdate) > currentDate){
          check = false
        }
        if(ValidationUtil.isNotNullAndNotEmpty(edate) && Number(edate) <= currentDate ){
          check = false
        }
        return check;
      }else{
        return false;
      }


    }

     getCurrentDate(): string {
      const currentDate = new Date();

      const year = currentDate.getFullYear();
      const month = (currentDate.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-indexed
      const day = currentDate.getDate().toString().padStart(2, '0');

      return `${year}${month}${day}`;
  }

  handleOnChangeQuanity(type: string): void {
	if (type) {
	  let quantity = this.quantities;
	  if (!quantity) {
		quantity = 0;
	  }
	  if (type === this.plus) {
		quantity++;
	  } else if (type === this.minus) {
		if (quantity > 0) {
		  quantity--;
		  if(quantity <= 0){
			quantity = 1;
		  }
		}
	  }
	  this.quantities = quantity;
	}
  }

}
